// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import createClaimModal from '../../../shared/reducers/create-claim-modal';
import customer from './customer';
import facets from './facets';
import filteredSearchResults from './filtered-search-results';
import highRentalDays from '../../shared/reducers/high-rental';
import product from './product';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';
import searchResults from './search-results';
import statusChangeModal from './status-change-modal-visibility';

export default {
    productSearch: combineReducers({
        busyCounter,
        createClaimModal,
        customer,
        facets,
        filteredSearchResults,
        highRentalDays,
        product,
        reportsAccordion,
        searchByDropDown,
        searchFilters,
        searchQueryString,
        searchResults,
        statusChangeModal
    })
};



// WEBPACK FOOTER //
// ./src/product/search/reducers/index.js